import { isAuthResponseHash } from './removeAuthResponseHash.utils';

/**
 * Removes a leftover auth response fragment (`#state=...&code=...`) from a URL.
 *
 * MSAL reads the response from the address bar before its own cached response,
 * so starting a login (or restoring a deep link) from a URL that still carries an
 * old `#state=` makes the next redirect fail with `state_mismatch` on every attempt.
 * Regular fragments (e.g. `#top`) are kept. Only the fragment is checked, matching
 * MSAL's default `responseMode: fragment`.
 */
export function removeAuthResponseHash(url: string): string {
  const hashIndex = url.indexOf('#');
  if (hashIndex === -1) {
    return url;
  }

  return isAuthResponseHash(url.slice(hashIndex + 1))
    ? url.slice(0, hashIndex)
    : url;
}
